import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const requestIssueInvoice = info =>
  call(websocketFetch, 'charge_group_credit', {
    ...info,
    invoice_type: 'ad_hoc_fees',
  });
